import React from 'react';
import { ArrowRightIcon } from './icons/CustomIcons';
export function CallToAction() {
  return <div className="w-full py-16 px-4 md:px-8 lg:px-16 bg-gradient-to-b from-[#0c2340] to-[#1a3a6c] text-white" data-id="element-31">
      <div className="max-w-4xl mx-auto text-center" data-id="element-32">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#e9d28f]" data-id="element-33">
          Secure Your Copy Now
        </h2>
        <p className="text-xl mb-8" data-id="element-34">
          Because history will remember those who stood strong… and you'll know
          you were one of them.
        </p>
        <button onClick={() => {
        document.getElementById('pricing-section').scrollIntoView({
          behavior: 'smooth'
        });
      }} className="bg-red-700 hover:bg-red-800 text-white font-bold py-4 px-10 rounded-md text-xl transition duration-300 flex items-center mx-auto" data-id="element-35">
          Get Your Copy Today
          <ArrowRightIcon className="ml-2 h-6 w-6" data-id="element-36" />
        </button>
        <div className="mt-12 flex flex-col md:flex-row justify-center items-center gap-6" data-id="element-37">
          <div className="relative" data-id="element-38">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8trgeA7VZR5XjJR2ciDSJW/Generated_Image_September_26%2C_2025_-_6_11PM.png" alt="Unshakable Conviction Book Cover" className="w-48 h-auto rounded-md shadow-xl" data-id="element-39" />
            <div className="absolute -top-3 -right-3 bg-red-700 text-white font-bold py-1 px-3 rounded-full shadow-lg text-sm" data-id="element-40">
              Premium Hardcover
            </div>
          </div>
          <div className="text-left" data-id="element-41">
            <h3 className="text-2xl font-bold mb-2" data-id="element-42">Unshakable Conviction</h3>
            <p className="text-lg mb-2" data-id="element-43">By Charlie Kirk</p>
            <p className="text-lg mb-4" data-id="element-44">
              How Faith, Freedom, and Courage Build Movements That Last
            </p>
            <div className="flex items-center" data-id="element-45">
              <div className="flex items-center mr-4" data-id="element-46">
                <span className="text-yellow-400" data-id="element-47">★★★★★</span>
                <span className="ml-1" data-id="element-48">5.0</span>
              </div>
              <span data-id="element-49">(1273 reviews)</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}